import { useEffect, useState } from 'react';
import { MOBILE_MAX } from '../service/constants';

const useIsMobile = () => {
  const query = `(max-width: ${MOBILE_MAX}px)`;
  const [isMobile, setIsMobile] = useState(() => window.matchMedia(query).matches);

  useEffect(() => {
    const media = window.matchMedia(query);
    const handler = (e) => setIsMobile(e.matches);
    media.addEventListener('change', handler);
    return () => media.removeEventListener('change', handler);
  }, [query]);

  return isMobile;
};

export default useIsMobile;
